import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-delete.ts
const deleteSpaceResponseSchema = z$1.strictObject({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	deleted: z$1.literal(true)
});
//#endregion
export { deleteSpaceResponseSchema };

//# sourceMappingURL=space-delete.js.map